import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import get from "lodash/get";
import { STATE_KEYS } from "utils/constants/state";
import ProductShow from "./ProductShow";
import ProductOrderSettings from "./ProductOrderSettings";
import { SchemaPropTypes } from "utils/propTypes";
import { getSchemaValuesForEditor } from "utils/schema";
import { addProductToCollection } from "utils/product";

const ProductOrderHub = (props) => {
  const { name } = props;

  const { values, setValues, setFieldTouched } = useFormikContext();
  const propertyKey = "products";
  const productsPath = `${name}.data.${propertyKey}`;
  const products = get(values, productsPath, []);

  const { template } = getSchemaValuesForEditor({
    name,
    propertyKey,
    schema: props.schema
  });

  const addProduct = addProductToCollection({
    values,
    setValues,
    setFieldTouched,
    template,
    productsPath
  });

  const activeIndex = get(values, STATE_KEYS.EDITOR.MENU_ACTIVE_INDEX);
  const activeProduct = products[activeIndex];
  const showProduct = Boolean(activeProduct);

  let content = null;

  if (showProduct) {
    content = (
      <ProductShow
        key={activeProduct.uuid}
        activeIndex={activeIndex}
        addProduct={addProduct}
        {...props}
      />
    );
  } else {
    content = <ProductOrderSettings addProduct={addProduct} {...props} />;
  }
  return content;
};

ProductOrderHub.propTypes = {
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  schema: PropTypes.shape(SchemaPropTypes)
};

export default ProductOrderHub;
